import NumericStepperInput from '@/components/common/NumericStepperInput';

export function QuantityReceivedTableCell({
  value,
  disabled,
  onChange,
  max,
}: {
  value: number;
  disabled: boolean;
  onChange: (value: number) => void;
  max: number;
}) {
  return <NumericStepperInput disabled={disabled} value={value} onChange={onChange} max={max} />;
}
